import { SPINESIM_MODALITIES } from "../../../classes/enums/MedicalImagesEnum";
import ViewLoader from "../../../components/viewLoader/ViewLoader";
import DxViewer from "../dxViewer/DxViewer";
import RadioDensity from "../radioDensity/RadioDensity";
import SliceViewer from "../sliceViewer/SliceViewer";
import VolumeViewer from "../volumeViewer/VolumeViewer";

/**
 * Grid component for displaying modality-specific viewers in Check module
 * Handles switching between different viewer types based on selected modality
 */
const ModalityGrid = ({
  selectedModality,
  isLoading,
  isRadioDensityActive,
  filteredViews,
  selectedTwin,
  areViewsReady,
  groupedThumbnailsStandard,
  twinId,
  digitalTwinSurgeryCache,
  renderClient,
  annotations,
  isDataFusionActive,
  handleImageClose,
  changeCtFusionSlice,
  addCustomMeasurement,
  isViewClosing,
  onRadioDensityStatisticsUpdate,
  planId,
  initialVertebraDimensions,
  loadingMessage,
}) => {
  const renderRadioDensityView = () => {
    return (
      <RadioDensity
        selectedTwin={selectedTwin}
        areViewsReady={areViewsReady}
        selectedModality={selectedModality}
        groupedThumbnailsStandard={groupedThumbnailsStandard}
        twinId={twinId}
        digitalTwinSurgeryCache={digitalTwinSurgeryCache}
        renderClient={renderClient}
        annotations={annotations}
        onStatisticsUpdate={onRadioDensityStatisticsUpdate}
        planId={planId}
        initialVertebraDimensions={initialVertebraDimensions}
      />
    );
  };

  if (!selectedModality) {
    return <div className="no-view-message"></div>;
  }

  if (isLoading) {
    return (
      <ViewLoader
        isLoading={true}
        message={loadingMessage}
      ></ViewLoader>
    );
  }

  if (isRadioDensityActive) {
    return renderRadioDensityView();
  }

  if (filteredViews.length === 0) {
    return (
      <div className="no-view-message">
        No {selectedModality} views available
      </div>
    );
  }

  switch (selectedModality) {
    case SPINESIM_MODALITIES.DX:
      return (
        <DxViewer
          views={filteredViews}
          handleImageClose={handleImageClose}
          renderClient={renderClient}
          isDataFusionActive={isDataFusionActive}
          changeCtFusionSlice={changeCtFusionSlice}
          addCustomMeasurement={addCustomMeasurement}
          isViewClosing={isViewClosing}
          planId={planId}
        />
      );
    case SPINESIM_MODALITIES.CT:
    case SPINESIM_MODALITIES.MR:
      return (
        <SliceViewer
          views={filteredViews}
          modality={selectedModality}
          handleImageClose={handleImageClose}
          renderClient={renderClient}
          isViewClosing={isViewClosing}
          planId={planId}
        />
      );
    case SPINESIM_MODALITIES.CT_VOLUME:
    case SPINESIM_MODALITIES.MR_VOLUME:
      return (
        <VolumeViewer
          views={filteredViews}
          modality={selectedModality}
          handleImageClose={handleImageClose}
          renderClient={renderClient}
          isViewClosing={isViewClosing}
          planId={planId}
        />
      );
    default:
      return (
        <div className="no-view-message">
          Unsupported modality: {selectedModality}
        </div>
      );
  }
};

export default ModalityGrid;
